import { render, staticRenderFns } from "./nyzx.vue?vue&type=template&id=0ff64fc6&scoped=true"
import script from "./nyzx.vue?vue&type=script&lang=js"
export * from "./nyzx.vue?vue&type=script&lang=js"
import style0 from "./nyzx.vue?vue&type=style&index=0&id=0ff64fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff64fc6",
  null
  
)

export default component.exports